interface PropsType {
  style?: React.CSSProperties;
  color?: string;
}

const UnlimitedIcon = (props: PropsType) => {
  return (
    <svg width="29" height="14" viewBox="0 0 29 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.7345 0C19.9705 0 18.416 0.57788 16.9815 1.76686C16.4576 2.20078 15.9813 2.69107 15.5377 3.20854C16.2579 4.20826 17.2263 5.68114 17.5269 6.14073C18.7749 4.51733 19.9651 3.44866 21.735 3.44866C23.8128 3.44866 25.5029 5.04185 25.5029 6.9995C25.5029 8.95714 23.8128 10.5503 21.735 10.5503C19.6571 10.5503 18.3925 9.09456 16.8929 6.9995C16.5981 6.553 15.2532 4.52186 14.745 3.78693C14.5467 3.5005 13.5421 2.35934 12.8263 1.76636C11.3913 0.57788 9.83633 0 8.07281 0C4.14527 0 0.950165 3.14008 0.950165 7C0.950165 10.8599 4.14527 14 8.07281 14C9.83682 14 11.3913 13.4221 12.8258 12.2331C13.3472 11.8012 13.8216 11.3135 14.2633 10.799C13.4412 9.63771 12.2828 7.85625 12.2828 7.85625C11.0344 9.48116 9.84368 10.5508 8.07281 10.5508C5.99496 10.5508 4.30488 8.95764 4.30488 7C4.30488 5.04236 5.99496 3.44916 8.07281 3.44916C10.1507 3.44916 11.3056 4.77859 12.8043 6.87466C12.8043 6.87466 14.9301 10.0414 14.9423 10.059C15.5504 10.8433 16.2153 11.5984 16.981 12.2331C18.4155 13.4221 19.9705 14 21.734 14C25.6615 14 28.8566 10.8599 28.8566 7C28.8566 3.14008 25.662 0 21.7345 0Z"
        fill="white"
      />
    </svg>
  );
};

export default UnlimitedIcon;
